export enum Pagination {
    First = 'FIRST',
    Previous = 'PREVIOUS',
    Next = 'NEXT',
    Last = 'LAST',
}

export enum ContentAgeRestriction {
    fourPlus = 4,
    ninePlus = 9,
    twelvePlus = 12,
    seventeenPlus = 17
}
